import { useStore } from "..";
export const useOrganizationQuota = () => useStore(({ organizationQuota }) => organizationQuota);
